import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Color,
  Text,
  Heading6,
  Space,
  Paragraph,
  Button,
  ButtonSize,
} from '@gousto-internal/citrus-react'
import { workingHours } from '../../config/workingHours'
import { store } from '../../store'
import { getIsAuthenticated } from '../../selectors/auth'
import { externalGoustoPages } from '../../config/routes'

const GetInTouch = ({ entityId, location }) => {
  const { state } = useContext(store)
  const isAuthenticated = getIsAuthenticated(state)
  const description = 'If you can’t find the answer to what you’re looking for here, our Customer Care team will be able to help.'
  const trackingProperty = JSON.stringify({
    location,
    entity_id: entityId,
    logged_in: isAuthenticated,
  })

  return (
    <Box
      bg={Color.NeutralGrey_50}
      paddingH={6}
      paddingV={5}
    >
      <Heading6>
        Still need help?
      </Heading6>
      <Space size={2} />
      <Paragraph>
        {description}
      </Paragraph>
      <Space size={3} />
      <Box
        data-tracking-action="kb_click_get_in_touch"
        data-tracking-property={trackingProperty}
      >
        <Button
          size={ButtonSize.Large}
          onClick={() => window.location.assign(externalGoustoPages.contactUs)}
        >
          Contact us
        </Button>
      </Box>
      <Space size={3} />
      <Text
        color={Color.NeutralGrey_600}
        size={1}
      >
        {workingHours.weekdays}
      </Text>
      <Text
        color={Color.NeutralGrey_600}
        size={1}
      >
        {workingHours.weekend}
      </Text>
    </Box>
  )
}

GetInTouch.propTypes = {
  entityId: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
}

export { GetInTouch }
